import type { ProviderRegistration, RefereeRegistration } from "@/types";

export function refereeContactTemplate(registration: RefereeRegistration): { subject: string; html: string } {
  const subject = `PuntoPadel — Sobre tu solicitud como árbitro`;
  const html = `<p>Hola ${registration.nombre},</p>
<p>Gracias por registrarte como árbitro en PuntoPadel. Hemos recibido tu solicitud y nos gustaría hablar contigo antes de activar tu cuenta.</p>
<p>¿Cuándo te vendría bien una breve llamada esta semana?</p>
<p>Un saludo,<br/>Equipo PuntoPadel</p>`;
  return { subject, html };
}

export function providerContactTemplate(registration: ProviderRegistration): { subject: string; html: string } {
  const subject = `PuntoPadel — Sobre tu solicitud para ${registration.companyName}`;
  const html = `<p>Hola ${registration.contactName},</p>
<p>Gracias por vuestro interés en PuntoPadel para <strong>${registration.companyName}</strong>. Hemos recibido vuestra solicitud y nos encantaría contaros más sobre cómo podemos ayudaros a gestionar reservas, marcadores y rankings.</p>
<p>¿Cuándo os vendría bien una breve llamada esta semana?</p>
<p>Un saludo,<br/>Equipo PuntoPadel</p>`;
  return { subject, html };
}
